import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Club } from '../../models/Club/clubs';
import { DetailsUser } from '../../models/Users/detailsUsers';
import { RegateResult } from '../../models/Regate/regate';

@Injectable({
  providedIn: 'root'
})
export class FfvapiService {

  constructor(
    private http: HttpClient
  ) { }

  /* ----------------------------------- GET ---------------------------------- */

  getAll(lat: number = null, long: number = null): Observable<Club[]> {
    if (lat && long) {
      return this.http.get<Club[]>(`${environment.apiUrl}/FFVApi/structures/lat/${lat}/long/${long}`);
    }
    else {
      return this.http.get<Club[]>(`${environment.apiUrl}/FFVApi/structures`);
    }
  }

  getLicencePdf() {
    return this.http.get<string>(`${environment.apiUrl}/FFVApi/licence/pdf`);
  }
  getLicencePng() {
    return this.http.get<string>(`${environment.apiUrl}/FFVApi/licence/png`);
  }

  getRegateByUser(): Observable<RegateResult[]> {
    const url = `${environment.apiUrl}/FFVapi/user/regates`;
    return this.http.get<RegateResult[]>(encodeURI(url));
  }

  getDetailsUser() {
    return this.http.get<DetailsUser>(`${environment.apiUrl}/FFVApi/user/details`);

  }

  checkIfALicence() {
    return this.http.get<any>(`${environment.apiUrl}/FFVApi/licence/check`);

  }

  getClubByUser(code: string) {
    return this.http.get<Club>(`${environment.apiUrl}/FFVApi/structures/${code}`);
  }

  /* -------------------------------------------------------------------------- */


}
